<template>
    <svg
        class="perp-tools-icon"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        <path
            d="M5.15 1.5H14.85L19 10L14.85 18.5H5.15L1 10L5.15 1.5Z"
            fill="#4E7F99"
            stroke="#061824"
            stroke-width="1"
            stroke-linejoin="round"
        />
        <path
            d="M6.7 5.35H13.3L16.45 10L13.3 14.65H6.7L3.55 10L6.7 5.35Z"
            fill="#2CFAFF"
            opacity="0.72"
        />
        <path
            d="M7.25 6.2H12.75L15.35 10L12.75 13.8H7.25L4.65 10L7.25 6.2Z"
            fill="#04121B"
            stroke="#07141B"
            stroke-width="0.7"
            stroke-linejoin="round"
        />
        <circle cx="10" cy="10" r="3.15" fill="#5C95B1" />
        <path
            d="M10 6.85V10L7.75 7.8C8.33 7.22 9.12 6.85 10 6.85Z"
            fill="#8CC4DA"
            opacity="0.75"
        />
        <path
            d="M10 10L13.05 8.95C13.18 9.28 13.25 9.63 13.25 10C13.25 10.42 13.17 10.82 13.02 11.18L10 10Z"
            fill="#86BDD4"
            opacity="0.62"
        />
        <path
            d="M10 10L11.6 12.72C11.14 12.98 10.6 13.15 10 13.15C9.48 13.15 8.98 13.03 8.55 12.8L10 10Z"
            fill="#477F9B"
            opacity="0.82"
        />
        <path
            d="M10 10L6.95 10.95C6.82 10.65 6.75 10.33 6.75 10C6.75 9.5 6.86 9.03 7.08 8.62L10 10Z"
            fill="#2F617B"
            opacity="0.72"
        />
        <circle
            cx="10"
            cy="10"
            r="3.15"
            stroke="#75B2CC"
            stroke-width="0.55"
        />
        <path
            d="M6.4 4.75H13.6"
            stroke="#60F5FA"
            stroke-width="0.8"
            stroke-linecap="round"
            opacity="0.8"
        />
    </svg>
</template>

<style scoped>
.perp-tools-icon {
    display: block;
    width: 20px;
    height: 20px;
    flex: 0 0 20px;
    shape-rendering: geometricPrecision;
}
</style>
